import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import { ICourseDiff } from '../../../../ng2/shared/typings/interfaces/course-diff.interface';
import { IGapPlan } from '../../../../ng2/shared/typings/interfaces/gap-plan.interface';
import { ISchool, TCreditSubjAreas } from '../../../../ng2/shared/typings/interfaces/school.interface';
import { IStudent } from '../../../../ng2/shared/typings/interfaces/student.interface';

export interface ITermDetails {
  termType: 'FUTURE' | 'CURRENT' | 'NEXT';
  value: number | null; // Actual term value, E.g. '171'
}

export interface IUserFilter {
  subjectArea?: TCreditSubjAreas;
  period?: any;
  courseCodeWithSection?: string;
}

const TEMP_CACHE = {
  courseDiffs: {},
  gapPlans: {},
};

export class CreditGapCoursePickerModal {
  static $inject = ['$mdDialog', 'CourseDiff', 'GapPlan', 'UtilitiesService'];

  constructor(private $mdDialog, private courseDiff, private gapPlan, private utils: UtilitiesService) {}

  /**
   *
   */
  show(
    studentCourseDiffs: ICourseDiff[],
    studentGapPlans: IGapPlan[],
    termDetails: ITermDetails,
    school: ISchool,
    student: IStudent,
    initialFilter?: IUserFilter,
  ) {
    const { termType, value: termYear } = termDetails;

    const courseDiff = this.courseDiff;
    const gapPlan = this.gapPlan;

    let modalTitle;
    switch (termType) {
      case 'FUTURE':
        modalTitle = 'Add courses to future terms';
        break;
      case 'CURRENT':
        modalTitle = 'Add courses to this term';
        break;
      case 'NEXT':
        const termYearHuman = this.utils.getHumanReadableTerm(termYear);
        modalTitle = `Add courses to term ${termYearHuman}`;
        break;
      default:
        throw new Error(`termDetails termType of ${termType} is not valid`);
    }

    const closeModal = () => {
      this.$mdDialog.hide();
    };

    return this.$mdDialog.show({
      disableParentScroll: true,
      template: require('./credit-gaps-course-picker-modal.html'),
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      controller(
        termYear,
        modalTitle,
        studentGapPlans,
        studentCourseDiffs,
        schoolCourseDiffs,
        schoolGapPlans,
        student,
        school,
        termType,
        initialFilter,
      ) {
        this.termYear = termYear;
        this.termType = termType;
        this.initialFilter = initialFilter;
        this.modalTitle = modalTitle;
        this.studentCourseDiffs = studentCourseDiffs;
        this.studentGapPlans = studentGapPlans;
        this.studentCourseDiffs = studentCourseDiffs;
        this.studentGapPlans = studentGapPlans;
        this.schoolCourseDiffs = schoolCourseDiffs;
        this.schoolGapPlans = schoolGapPlans;
        this.student = student;
        this.school = school;
        this.closeModal = () => closeModal();
      },
      controllerAs: '$ctrl',
      locals: {
        termYear,
        modalTitle,
        studentGapPlans,
        studentCourseDiffs,
        student,
        school,
        termType,
        initialFilter,
      },
      resolve: {
        // TODO: move data fetch to SDC store and only fetch one time (JC)
        // and remove the TEMP_CACHE - a temp solution to avoiding multiple fetches of same data
        schoolCourseDiffs() {
          const schoolId = school._id;
          if (TEMP_CACHE.courseDiffs[schoolId]) {
            return Promise.resolve(TEMP_CACHE.courseDiffs[schoolId]);
          }
          return courseDiff
            .where({ schoolId, status: 'PENDING' })
            .$promise.then(courseDiffs => {
              TEMP_CACHE.courseDiffs[schoolId] = courseDiffs;
              return courseDiffs;
            })
            .catch(err => {
              // TODO: handle error
              console.error(err);
            });
        },
        schoolGapPlans() {
          const schoolId = school._id;
          if (TEMP_CACHE.gapPlans[schoolId]) {
            return Promise.resolve(TEMP_CACHE.gapPlans[schoolId]);
          }
          return gapPlan
            .where({ schoolId, status: 'ACTIVE' })
            .$promise.then(gapPlans => {
              TEMP_CACHE.gapPlans[schoolId] = gapPlans;
              return gapPlans;
            })
            .catch(err => {
              // TODO: handle error
              console.error(err);
            });
        },
      },
    });
  }
}
